import Vue from 'vue';
import VueRouter from 'vue-router';
import innovative from './innovative';
import mastery from './mastery';
import giant from './giant';
import science from './science';
import technology from './technology';
import report from './report';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/layout'
  },
  {
    path: '/layout',
    redirect: '/mastery',
    component: () => import('../views/index.vue'),
    children: [
      ...innovative,
      ...mastery,
      ...giant,
      ...science,
      ...technology,
      ...report,
      {
        path: '/scale',
        name: 'scale',
        component: () => import('../views/scale/index.vue')
      },
    ]
  },
  {
    path: '/result_report',
    name: 'result_report',
    component: () => import('../views/report/result.vue'),
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('../views/history/index.vue')
  },
  {
    path: '/recycle',
    name: 'recycle',
    component: () => import('../views/recycle/index.vue')
  },
  {
    path: '/manage',
    name: 'manage',
    meta: { title: '后台管理中心' },
    component: () => import('../views/manage/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '平台用户登录' },
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: '平台用户注册' },
    component: () => import('../views/register/index.vue')
  },
  {
    path: "/supplierAllBack",
    name: "SupplierAllBack",
    component: () => import('../views/supplierAllBack.vue'),
  },
  { path: "*", redirect: "/404" },
  {
    path: "/404",
    meta: { title: '404页面错误' },
    component: () => import("@/views/404.vue"),
  }
];

const router = new VueRouter({
  routes,
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // 页面刷新回滚顶部
    return { x: 0, y: 0 }
  }
});

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default router;
